export default "__VITE_ASSET__DX0loSmW__"